module.exports = __webpack_public_path__ + "static/media/sample_template.e6f10445.xlsx";